import type { Language } from "@/i18n/translations";

type PageTranslations = Record<Language, Record<string, string>>;

export const pageTranslations: PageTranslations = {
  pt: {
    "common.actions": "Acoes",
    "common.action": "Acao",
    "common.refresh": "Atualizar",
    "common.open": "Abrir",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.create": "Criar",
    "common.creating": "A criar...",
    "common.saving": "A guardar...",
    "common.search": "Pesquisar",
    "common.client": "Cliente",
    "common.noClient": "Sem cliente",
    "common.status": "Estado",
    "common.updated": "Atualizado",
    "common.total": "Total",
    "common.price": "Preco",
    "common.unit": "Unid.",
    "common.category": "Categoria",
    "common.file": "Ficheiro",
    "common.budget": "Orcamento",
    "common.work": "Obra",
    "common.project": "Projeto",
    "common.value": "Valor",
    "common.none": "Nenhum",
    "status.draft": "Rascunho",
    "status.sent": "Enviado",
    "status.approved": "Aprovado",
    "status.rejected": "Rejeitado",
    "status.expired": "Expirado",
    "status.waitingApproval": "A aguardar aprovacao",
    "status.ready": "Apto",
    "clientType.private": "Particular",
    "clientType.company": "Empresa",
    "clientType.public": "Publico",
    "clientType.other": "Outro",
    "appShell.toggleNavigation": "Abrir navegacao",
    "appShell.workspace": "Workspace Orzio",
    "analytics.period.month": "Mes",
    "analytics.period.quarter": "Trimestre",
    "analytics.period.year": "Ano",
    "analytics.previous.month": "vs mes anterior",
    "analytics.previous.quarter": "vs trimestre anterior",
    "analytics.previous.year": "vs ano anterior",
    "analytics.previous.yoy": "vs ano anterior",
    "analytics.delta.new": "novo",
    "analytics.eyebrow": "Analise",
    "analytics.title": "Dashboard",
    "analytics.description": "Visao analitica do teu portfolio de orcamentos.",
    "analytics.empty.title": "Ainda sem orcamentos",
    "analytics.empty.description": "Cria o teu primeiro orcamento para comecar a ver metricas, graficos e comparativos do portfolio.",
    "analytics.empty.cta": "Criar orcamento",
    "analytics.error.stale": "Nao foi possivel atualizar os dados. A mostrar a ultima informacao disponivel.",
    "analytics.kpi.generatedValue": "Valor gerado",
    "analytics.kpi.approvedValue": "Valor aprovado",
    "analytics.kpi.conversionRate": "Taxa de conversao",
    "analytics.kpi.averageMargin": "Margem media",
    "analytics.alerts.title": "Alertas acionaveis",
    "analytics.alert.expiring.title": "Orcamentos a expirar",
    "analytics.alert.expiring.desc": "Validade termina nos proximos 7 dias",
    "analytics.alert.noResponse.title": "Sem resposta",
    "analytics.alert.noResponse.desc": "Enviados ha mais de 7 dias sem retorno",
    "analytics.alert.lowMargin.title": "Margem baixa",
    "analytics.alert.lowMargin.desc": "Orcamentos abertos abaixo de 15% de margem",
    "analytics.alert.stale.title": "Orcamentos parados",
    "analytics.alert.stale.desc": "Em aberto sem atividade ha mais de 14 dias",
    "analytics.alerts.empty": "Sem alertas. Portfolio em dia.",
    "analytics.chart.funnel": "Funil de conversao",
    "analytics.chart.evolution": "Evolucao de orcamentos",
    "analytics.chart.evolutionHint": "ultimos 6 meses",
    "analytics.chart.margin": "Erosao de margem",
    "analytics.chart.marginHint": "aprovados, top 8",
    "analytics.chart.typeSplit": "Projetos vs Obras",
    "analytics.chart.topClients": "Top clientes",
    "analytics.chart.topClientsHint": "por valor gerado no periodo",
    "analytics.chart.emptyPeriod": "Sem orcamentos no periodo",
    "analytics.chart.emptyApproved": "Sem orcamentos aprovados no periodo",
    "analytics.chart.emptyClients": "Sem clientes identificados no periodo",
    "analytics.chart.budgetSingular": "orcamento",
    "analytics.chart.budgetPlural": "orcamentos",
    "analytics.chart.budgets": "Orcamentos",
    "analytics.chart.plannedMargin": "Margem planeada",
    "analytics.chart.effectiveMargin": "Margem efetiva",
    "analytics.funnel.created": "Criados",
    "analytics.funnel.sent": "Enviados",
    "analytics.funnel.approved": "Aprovados",
    "analytics.type.projects": "Projetos",
    "analytics.type.works": "Obras",
    "analytics.stat.avgTicket": "Ticket medio",
    "analytics.stat.salesCycle": "Ciclo de venda",
    "analytics.stat.days": "dias",
    "analytics.stat.noData": "-",
    "analytics.stat.decidedApprox": "{count} orcamento{plural} decidido{plural} / aproximado",
    "analytics.stat.notEnoughData": "Sem dados suficientes no periodo",
    "analytics.viewBudgets.title": "Ver todos os orcamentos",
    "analytics.viewBudgets.desc": "Lista completa, filtros e acoes",
    "templates.eyebrow": "Biblioteca P0",
    "templates.title": "Modelos para criar um orcamento em minutos",
    "templates.description": "{validated} modelos validados e {editable} bases editaveis geram um BudgetDraft com capitulos, partidas, totais e margem minima.",
    "templates.search": "Pesquisar tipologia, disciplina ou escopo",
    "templates.filter.all": "Todos",
    "templates.filter.works": "Obra",
    "templates.filter.projects": "Projeto",
    "templates.tab.validated": "Validados ({count})",
    "templates.tab.base": "Bases editaveis ({count})",
    "templates.maturity.validated": "Validado",
    "templates.maturity.validatedDesc": "Revisto para um primeiro orcamento com capitulos, partidas e margem.",
    "templates.maturity.baseEditable": "Base editavel",
    "templates.maturity.baseEditableDesc": "Estrutura util para adaptar quantidades, materiais e ambito.",
    "templates.base": "Base",
    "templates.duration": "Prazo",
    "templates.days": "dias",
    "templates.risk": "Risco",
    "templates.margin": "Margem",
    "templates.includes": "Inclui",
    "templates.viewDetail": "Ver detalhe",
    "templates.empty": "Nenhum modelo corresponde aos filtros ativos.",
    "templates.upgradeRequired": "Upgrade necessario",
    "templates.moduleNotIncluded": "Este tipo de orcamento nao esta incluido no plano atual.",
    "templates.limitReached": "Atingiu o limite de orcamentos ativos do plano atual.",
    "templates.created": "Orcamento criado",
    "templates.createdDesc": "{title} ficou pronto para edicao.",
    "templates.createError": "Nao foi possivel criar o orcamento",
    "templates.discipline.residential": "Residencial",
    "templates.discipline.commercial": "Comercial",
    "templates.discipline.healthcare": "Saude",
    "templates.discipline.hospitality": "Hotelaria",
    "templates.discipline.industrial": "Industrial",
    "templates.discipline.public_space": "Espaco publico",
    "templates.discipline.technical": "Tecnico",
    "templateDetail.validated.description": "Modelo revisto para criar um primeiro orcamento com confianca.",
    "templateDetail.editable.description": "Estrutura inicial para adaptar quantidades, marcas e ambito.",
    "templateDetail.notFound": "Modelo nao encontrado",
    "templateDetail.notFoundDesc": "Volte a biblioteca e escolha outro modelo.",
    "templateDetail.back": "Voltar aos modelos",
    "templateDetail.work": "Obra",
    "templateDetail.project": "Projeto",
    "templateDetail.risk": "Risco {value}%",
    "templateDetail.margin": "Margem {value}%",
    "templateDetail.baseTotal": "Total base",
    "templateDetail.chapters": "Capitulos",
    "templateDetail.items": "Partidas",
    "templateDetail.duration": "Prazo",
    "templateDetail.chapterBreakdown": "Desglose por capitulos",
    "templateDetail.technicalAssumptions": "Premissas tecnicas",
    "templateDetail.assumption1": "Valores base sujeitos a visita, medicao e validacao tecnica.",
    "templateDetail.assumption2": "Quantidades e marcas devem ser ajustadas antes de enviar ao cliente.",
    "templateDetail.assumption3": "Margem minima preservada no editor para evitar orcamentos abaixo do risco.",
    "templateDetail.recommendedFor": "Recomendado para",
    "templateDetail.creating": "A criar...",
    "templateDetail.createFromTemplate": "Criar orcamento a partir deste modelo",
    "documents.eyebrow": "Centro documental",
    "documents.title": "Documentos",
    "documents.description": "Pre-visualize e exporte PDFs a partir das versoes existentes. O historico persistente de downloads sera ativado quando a tabela de exportacoes for promovida.",
    "documents.stat.budgets": "Orcamentos",
    "documents.stat.ready": "Prontos para documento",
    "documents.stat.history": "Historico",
    "documents.history.title": "Historico de documentos",
    "documents.history.desc": "Registo das pre-visualizacoes/exportacoes concluidas.",
    "documents.header.view": "Vista",
    "documents.header.created": "Criado",
    "documents.view.internal": "Interna",
    "documents.view.client": "Cliente",
    "documents.empty.history": "Ainda nao existem documentos gerados. Use o botao PDF num orcamento para criar o primeiro registo.",
    "documents.search": "Pesquisar por obra, cliente, tipo ou estado",
    "documents.empty.budgets": "Nenhum orcamento encontrado para gerar documento.",
    "documents.loadError": "Erro ao carregar documentos",
    "documents.loadErrorDesc": "Nao foi possivel carregar a lista de orcamentos.",
    "works.eyebrow": "Execucao",
    "works.title": "Obras",
    "works.description": "Orcamentos de obra aprovados entram aqui para gerar plano de execucao, medicoes e autos.",
    "works.stat.total": "Orcamentos de obra",
    "works.stat.approved": "Aprovados",
    "works.stat.pipeline": "Pipeline",
    "works.pipeline.ready": "Abrir execucao e gerar plano.",
    "works.pipeline.empty": "Aprove um orcamento de obra para comecar.",
    "works.search": "Pesquisar obra, cliente ou estado",
    "works.execution": "Execucao",
    "works.open": "Abrir obra",
    "works.editor": "Editor",
    "works.empty": "Nenhuma obra aprovada ainda. Aprove um orcamento de obra para criar a execucao.",
    "works.loadError": "Erro ao carregar obras",
    "works.loadErrorDesc": "Nao foi possivel carregar os orcamentos aprovados.",
    "measurementAutos.title": "Autos de medicao",
    "measurementAutos.noPermission": "Sem permissao para emitir ou gerir autos de medicao. Um administrador pode libertar este acesso nas permissoes do utilizador.",
    "measurementAutos.description": "Escolha um orcamento de obra aprovado para abrir diretamente a pagina de autos de medicao.",
    "measurementAutos.stat.ready": "Aptos a auto",
    "measurementAutos.stat.totalWorks": "Total de obras",
    "measurementAutos.stat.criteria": "Criterio",
    "measurementAutos.criteria": "Orcamentos de obra aprovados podem gerar autos.",
    "measurementAutos.search": "Pesquisar orcamento, cliente ou tipo",
    "measurementAutos.autos": "Autos",
    "measurementAutos.open": "Abrir autos",
    "measurementAutos.empty": "Nenhum orcamento de obra aprovado encontrado para autos de medicao.",
    "measurementAutos.loadError": "Erro ao carregar autos",
    "measurementAutos.loadErrorDesc": "Nao foi possivel carregar os orcamentos aptos a auto de medicao.",
    "revit.eyebrow": "BIM",
    "revit.title": "Importar Revit Orzio Takeoff",
    "revit.description": "Importe a planilha .xlsx gerada no Revit pelo Add-in Orzio Takeoff e continue a precificacao no assistente de orcamento.",
    "revit.selectFile": "Selecionar planilha",
    "revit.continueBudget": "Continuar orcamento",
    "revit.input": "Entrada",
    "revit.file": "Arquivo",
    "revit.noFile": "Nenhuma planilha selecionada",
    "revit.budgetName": "Nome do orcamento",
    "revit.budgetNamePlaceholder": "Ex.: Orzio Takeoff - Bloco A",
    "revit.preview": "Pre-visualizacao",
    "revit.previewDesc": "As partidas entram sem preco unitario para revisao antes de salvar o orcamento.",
    "revit.rows": "{count} linhas",
    "revit.model": "Modelo",
    "revit.phase": "Fase",
    "revit.toDefine": "A definir",
    "revit.extracted": "Extraido",
    "revit.quantity": "Quantidade",
    "revit.item": "Partida",
    "revit.countInUnit": "{count} em {unit}",
    "revit.emptyPreview": "Selecione a planilha .xlsx do Orzio Takeoff para ver os quantitativos.",
    "revit.imported": "Planilha importada",
    "revit.importedDesc": "{count} linhas de quantitativos ficaram prontas para revisao.",
    "revit.importFailed": "Importacao Revit falhou",
    "revit.readError": "Nao foi possivel ler a planilha gerada pelo Orzio Takeoff.",
    "revit.noDate": "Sem data",
    "bim.title": "Importacao IFC com fluxo orientado ao modelo",
    "bim.description": "Importe primeiro o modelo IFC, reveja os elementos extraidos e escolha depois se cria um novo orcamento ou associa a um orcamento existente.",
    "bim.currentState": "Estado atual",
    "bim.workflow.importado.label": "Importar IFC",
    "bim.workflow.importado.description": "Carregue um modelo IFC para rever os elementos extraidos.",
    "bim.workflow.importado.cta": "Importar IFC",
    "bim.workflow.destino.label": "Escolher destino",
    "bim.workflow.destino.description": "Importacao extraida e pendente de orcamento de destino.",
    "bim.workflow.destino.cta": "Escolher destino",
    "bim.workflow.mapeado.label": "Mapear composicoes",
    "bim.workflow.mapeado.description": "Associe composicoes aos elementos extraidos antes de calcular partidas.",
    "bim.workflow.mapeado.cta": "Mapear composicoes",
    "bim.workflow.calculado.label": "Calcular partidas",
    "bim.workflow.calculado.description": "As composicoes mapeadas podem gerar partidas calculadas.",
    "bim.workflow.calculado.cta": "Calcular partidas",
    "bim.workflow.editor.label": "Abrir editor",
    "bim.workflow.editor.description": "As partidas IFC estao prontas para revisao no editor.",
    "bim.workflow.editor.cta": "Abrir editor",
    "bim.metric.extracted": "Elementos extraidos",
    "bim.metric.mapped": "Elementos mapeados",
    "bim.metric.calculated": "Partidas calculadas",
    "bim.destination.title": "Destino da importacao",
    "bim.destination.empty": "Importe um IFC para escolher o destino.",
    "bim.destination.pending": "Importacao pendente de destino",
    "bim.createFromIfc.title": "Criar novo orcamento a partir deste IFC",
    "bim.createFromIfc.desc": "Use os elementos extraidos para iniciar um novo orcamento tecnico.",
    "bim.createFromIfc.button": "Criar novo orcamento",
    "bim.associate.title": "Associar a orcamento existente",
    "bim.associate.desc": "Ligue este modelo a um orcamento ja criado e continue o mapeamento.",
    "bim.associate.search": "Pesquisar por nome, cliente ou estado",
    "bim.associate.button": "Associar a este orcamento",
    "bim.associateManual.title": "Associacao manual por ID",
    "bim.associateManual.desc": "Use apenas se souber exatamente o identificador tecnico do orcamento.",
    "bim.associateManual.placeholder": "ID tecnico do orcamento",
    "bim.associateManual.button": "Associar",
    "bim.associatedTo": "Associado a",
    "bim.refreshState": "Atualizar estado",
    "bim.mapping.title": "Mapeamento e calculo",
    "bim.mapping.desc": "O mapeamento fica disponivel depois de escolher um orcamento de destino.",
    "bim.mapping.needDestination": "Escolha um orcamento de destino antes de mapear composicoes.",
    "bim.calculate": "Calcular partidas",
    "bim.openEditor": "Abrir editor",
    "bim.calculated.title": "Partidas IFC calculadas",
    "bim.calculated.desc": "{count} partidas preparadas para revisao no editor.",
    "bim.history.title": "Historico BIM/IFC",
    "bim.history.versions": "Versoes do modelo",
    "bim.history.noVersions": "Ainda nao ha versoes IFC registadas para este orcamento.",
    "bim.history.version": "Versao {number}",
    "bim.history.current": "Atual",
    "bim.history.model": "Modelo IFC",
    "bim.history.elements": "elementos",
    "bim.history.comparisons": "Comparacoes",
    "bim.history.noComparisons": "Nenhuma comparacao IFC gerada ainda.",
    "bim.history.changesTitle": "Alteracoes encontradas no novo IFC",
    "bim.history.changesSummary": "{added} adicionados / {removed} removidos / {changed} alterados / {uncertain} incertos",
    "bim.error.loadElements": "Nao foi possivel carregar elementos IFC",
    "bim.error.loadElementsDesc": "O ficheiro IFC foi importado, mas os elementos ainda nao puderam ser carregados.",
    "bim.toast.imported": "IFC importado com sucesso",
    "bim.toast.importedWithBudget": "{count} elementos foram extraidos e associados ao orcamento selecionado.",
    "bim.toast.importedNoBudget": "{count} elementos foram extraidos. Escolha agora o destino.",
    "bim.error.saveImport": "Nao foi possivel guardar a importacao IFC",
    "bim.error.saveImportDesc": "Verifique o ficheiro IFC e tente novamente.",
    "bim.toast.modelAssociated": "Modelo associado",
    "bim.toast.modelAssociatedDesc": "Ja pode mapear composicoes e calcular partidas.",
    "bim.error.associate": "Nao foi possivel associar o IFC ao orcamento",
    "bim.error.retrySoon": "Tente novamente dentro de instantes.",
    "bim.error.createBudget": "Nao foi possivel criar orcamento a partir do IFC",
    "bim.error.mapComposition": "Nao foi possivel mapear a composicao",
    "bim.error.selectDestination": "Escolha um orcamento de destino antes de calcular partidas.",
    "bim.error.mapBeforeCalculate": "Mapeie composicoes antes de calcular partidas.",
    "bim.error.mapBeforeCalculateDesc": "Pode rever os elementos extraidos e associar composicoes na tabela.",
    "bim.error.noCalculable": "Sem quantidades calculaveis",
    "bim.error.noCalculableDesc": "Reveja elementos com quantidades antes de calcular partidas.",
    "bim.toast.linesCalculated": "Partidas calculadas",
    "bim.toast.linesCalculatedDesc": "{count} partidas IFC estao prontas para revisao.",
    "contacts.eyebrow": "Diretorio comercial",
    "contacts.title": "Contactos",
    "contacts.description": "Clientes estruturados para associar a orcamentos, consultar historico e evitar nomes duplicados em texto livre.",
    "contacts.new": "Novo contacto",
    "contacts.stat.total": "Contactos",
    "contacts.stat.withBudgets": "Com orcamentos",
    "contacts.stat.pipeline": "Pipeline associado",
    "contacts.search": "Pesquisar por nome, NIF, email, telefone ou notas",
    "contacts.allTypes": "Todos os tipos",
    "contacts.actionsFor": "Acoes de {name}",
    "contacts.edit": "Editar contacto",
    "contacts.delete": "Excluir contacto",
    "contacts.budgets": "Orcamentos",
    "contacts.approved": "Aprovados",
    "contacts.lastBudget": "Ultimo orcamento:",
    "contacts.noHistory": "sem historico",
    "contacts.viewBudgets": "Ver orcamentos",
    "contacts.empty": "Nenhum contacto encontrado. Crie o primeiro cliente ou ajuste os filtros.",
    "contacts.dialog.editTitle": "Editar contacto",
    "contacts.dialog.newTitle": "Novo contacto",
    "contacts.dialog.editDesc": "Atualize os dados estruturados deste contacto.",
    "contacts.dialog.newDesc": "Este cliente fica disponivel no seletor do editor e no historico comercial.",
    "contacts.form.name": "Nome",
    "contacts.form.namePlaceholder": "Nome do cliente ou empresa",
    "contacts.form.tax": "NIF/NIPC",
    "contacts.form.email": "Email",
    "contacts.form.phone": "Telefone",
    "contacts.form.address": "Morada",
    "contacts.form.notes": "Notas",
    "contacts.form.notesPlaceholder": "Preferencias, contexto comercial ou observacoes internas",
    "contacts.saveChanges": "Guardar alteracoes",
    "contacts.create": "Criar contacto",
    "contacts.nameRequired": "Nome obrigatorio",
    "contacts.nameRequiredDesc": "Indique o nome do cliente antes de guardar.",
    "contacts.updated": "Contacto atualizado",
    "contacts.created": "Cliente criado",
    "contacts.deleted": "Contacto excluido",
    "contacts.createError": "Nao foi possivel criar o cliente",
    "contacts.updateError": "Nao foi possivel atualizar o contacto",
    "contacts.deleteError": "Nao foi possivel excluir o contacto",
    "contacts.loadError": "Erro ao carregar contactos",
    "contacts.loadErrorDesc": "Nao foi possivel carregar os clientes.",
    "contacts.deleteTitle": "Excluir contacto?",
    "contacts.deleteDesc": "Esta acao remove o contacto \"{name}\". Os orcamentos associados deixam de ter este contacto selecionado.",
    "contacts.deleting": "A excluir...",
    "clientSelect.private": "Particular",
    "clientSelect.company": "Empresa",
    "clientSelect.public": "Entidade publica",
    "clientSelect.other": "Outro",
    "clientSelect.placeholder": "Selecionar cliente",
    "clientSelect.search": "Procurar cliente...",
    "clientSelect.loading": "A carregar clientes",
    "clientSelect.empty": "Nenhum cliente encontrado.",
    "clientSelect.remove": "Remover cliente",
    "clientSelect.create": "Criar cliente",
    "clientSelect.namePlaceholder": "Nome do cliente",
    "clientSelect.createAria": "Criar cliente",
    "clientSelect.updateError": "Nao foi possivel atualizar o cliente.",
    "editor.backToBudgets": "Voltar aos orcamentos",
    "editor.budgetTrail": "Orcamentos /",
    "editor.referenceAria": "Referencia do orcamento",
    "editor.clientAria": "Cliente",
    "editor.clientPlaceholder": "Cliente por definir",
    "editor.save.idle": "Sem alteracoes",
    "editor.save.saving": "A guardar...",
    "editor.save.saved": "Guardado",
    "editor.save.error": "Erro ao guardar",
    "editor.saveButton.saving": "A guardar",
    "editor.saveButton": "Guardar",
    "editor.export": "Exportar",
    "editor.createWork": "Criar Obra",
    "editor.approve": "Aprovar",
    "editor.moreActions": "Mais acoes",
    "editor.duplicate": "Duplicar orcamento",
    "editor.newVersion": "Nova versao",
    "editor.versionHistory": "Historico de versoes",
    "editor.execution": "Execucao e medicao",
    "editor.importIfc": "Importar IFC",
    "permissions.budgets.view": "Ver orcamentos",
    "permissions.budgets.create": "Criar orcamentos",
    "permissions.budgets.edit": "Editar orcamentos",
    "permissions.budgets.delete": "Apagar orcamentos",
    "permissions.cost_bases.view": "Ver base de precos",
    "permissions.cost_bases.edit": "Editar base de precos",
    "permissions.cost_bases.delete": "Apagar base de precos",
    "permissions.team.manage": "Gerir equipa",
    "permissions.admin.access": "Aceder a areas administrativas",
    "costDatabase.resource.count": "{count} insumo{plural}",
    "costDatabase.resource.new": "Novo insumo",
    "costDatabase.resource.empty": "Nenhum insumo criado ainda. Crie o primeiro para comecar a montar composicoes.",
    "costDatabase.resource.name": "Nome",
    "costDatabase.resource.category": "Categoria",
    "costDatabase.resource.unit": "Unid.",
    "costDatabase.resource.price": "Preco",
    "costDatabase.resource.edit": "Editar",
    "costDatabase.resource.delete": "Eliminar",
    "costDatabase.resource.editTitle": "Editar insumo",
    "costDatabase.resource.newTitle": "Novo insumo",
    "costDatabase.resource.updated": "Insumo atualizado",
    "costDatabase.resource.created": "Insumo criado",
    "costDatabase.resource.form.name": "Nome",
    "costDatabase.resource.form.namePlaceholder": "Bloco ceramico 30x20x11",
    "costDatabase.resource.form.category": "Categoria",
    "costDatabase.resource.form.unit": "Unidade",
    "costDatabase.resource.form.basePrice": "Preco base (EUR)",
    "costDatabase.resource.form.priceSource": "Fonte de preco",
    "costDatabase.resource.form.selectSource": "Selecionar fonte",
    "costDatabase.resource.form.noSource": "Sem fonte",
    "costDatabase.resource.form.referenceDate": "Data de referencia",
    "costDatabase.resource.form.notes": "Notas",
    "costDatabase.resource.form.notesPlaceholder": "Observacoes opcionais",
    "costDatabase.resource.form.checkingBenchmark": "A consultar referencia de mercado...",
    "costDatabase.resource.form.accountReference": "Referencia da sua conta:",
    "costDatabase.resource.form.globalReference": "Referencia global:",
    "costDatabase.resource.form.ownObservations": "{count} observacao(oes) propria(s)",
    "costDatabase.resource.form.anonymousObservations": "{count} observacao(oes) anonima(s)",
    "costDatabase.resource.form.use": "Usar",
    "costDatabase.resource.form.aboveReference": "Valor acima da referencia em {value}%.",
    "costDatabase.resource.form.belowReference": "Valor abaixo da referencia em {value}%.",
    "costDatabase.resource.form.globalMean": "Media global:",
    "costDatabase.resource.form.globalMedian": "Mediana global:",
    "costDatabase.resource.form.noBenchmark": "Sem referencia suficiente para este insumo e unidade.",
    "costDatabase.resource.form.create": "Criar insumo",
    "costDatabase.resource.category.material": "Material",
    "costDatabase.resource.category.labor": "Mao de obra",
    "costDatabase.resource.category.equipment": "Equipamento",
    "costDatabase.resource.category.subcontract": "Subcontrato",
    "costDatabase.resource.category.other": "Outro",
    "costDatabase.dataTier.official": "Oficial",
    "costDatabase.dataTier.scraped": "Raspagem",
    "costDatabase.dataTier.user_edited": "Editado",
    "costDatabase.dataTier.ai_derived": "IA",
    "import.status.pending": "Pendente",
    "import.status.processing": "A processar",
    "import.status.review": "Em revisao",
    "import.status.completed": "Concluido",
    "import.status.failed": "Falhou",
    "costDatabase.composition.count": "{count} composic{plural}",
    "costDatabase.composition.new": "Nova composicao",
    "costDatabase.composition.empty": "Nenhuma composicao criada ainda. As composicoes agrupam insumos em trabalhos orcamentaveis.",
    "costDatabase.composition.resourcesRequired": "Crie insumos primeiro. Uma composicao precisa de pelo menos um recurso.",
    "costDatabase.composition.editTitle": "Editar composicao",
    "costDatabase.composition.newTitle": "Nova composicao",
    "costDatabase.composition.updated": "Composicao atualizada",
    "costDatabase.composition.created": "Composicao criada",
    "costDatabase.composition.status.active": "Ativa",
    "costDatabase.composition.status.draft": "Rascunho",
    "costDatabase.composition.status.archived": "Arquivada",
    "costDatabase.composition.form.code": "Codigo",
    "costDatabase.composition.form.unit": "Unidade",
    "costDatabase.composition.form.name": "Nome",
    "costDatabase.composition.form.namePlaceholder": "Parede interior alvenaria ceramica e/30",
    "costDatabase.composition.form.description": "Descricao",
    "costDatabase.composition.form.descriptionPlaceholder": "Especificacoes tecnicas, notas de execucao...",
    "costDatabase.composition.form.workCategory": "Categoria de trabalho",
    "costDatabase.composition.form.noCategory": "Sem categoria",
    "costDatabase.composition.form.discipline": "Disciplina",
    "costDatabase.composition.form.noDiscipline": "Sem disciplina",
    "costDatabase.composition.form.status": "Estado",
    "costDatabase.composition.form.selectPlaceholder": "Selecionar...",
    "costDatabase.composition.form.saveEdit": "Guardar alteracoes",
    "costDatabase.composition.form.saveCreate": "Criar composicao",
    "costDatabase.compositionItem.resource": "Recurso",
    "costDatabase.compositionItem.quantity": "Qtd/unid",
    "costDatabase.compositionItem.waste": "Perda %",
    "costDatabase.compositionItem.unitPrice": "Preco unit.",
    "costDatabase.compositionItem.totalUnitCost": "Custo unitario total:",
    "costDatabase.compositionItem.addResource": "Adicionar recurso",
    "costDatabase.compositionItem.selectResource": "Selecionar insumo...",
    "costDatabase.compositionItem.allResourcesAdded": "Todos os insumos ja adicionados",
    "costDatabase.compositionItem.add": "Adicionar",
    "import.upload.currencyRequired": "Moeda obrigatoria",
    "import.edit.title": "Editar importacao",
    "import.edit.description": "Ajuste os metadados desta base importada sem reenviar o ficheiro.",
    "import.edit.save": "Guardar alteracoes",
    "import.delete.title": "Eliminar importacao",
    "import.delete.description": "Vai eliminar a importacao \"{name}\". As linhas em staging, mapeamentos e conflitos associados serao removidos. Dados ja promovidos para a base principal nao sao apagados automaticamente.",
    "import.delete.descriptionFallback": "Vai eliminar esta importacao. As linhas em staging, mapeamentos e conflitos associados serao removidos. Dados ja promovidos para a base principal nao sao apagados automaticamente.",
    "import.updated": "Importacao atualizada",
    "import.deleted": "Importacao eliminada",
    "import.fileType.title": "Escolher tipo de ficheiro",
    "import.fileType.description": "Selecione primeiro o formato da base que quer importar. O quadro correspondente aparece logo abaixo.",
    "import.fileType.bc3.description": "Capitulos, composicoes e recursos estruturados.",
    "import.fileType.xlsx.description": "Planilhas de custos e catalogos tabulares.",
    "import.fileType.json.description": "Carga vinda de coletor externo ou integracao.",
    "import.jobs.count": "{count} job{plural} de importacao (BC3, XLSX, JSON...)"
  },
  en: {
    "common.actions": "Actions",
    "common.action": "Action",
    "common.refresh": "Refresh",
    "common.open": "Open",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.create": "Create",
    "common.creating": "Creating...",
    "common.saving": "Saving...",
    "common.search": "Search",
    "common.client": "Client",
    "common.noClient": "No client",
    "common.status": "Status",
    "common.updated": "Updated",
    "common.total": "Total",
    "common.price": "Price",
    "common.unit": "Unit",
    "common.category": "Category",
    "common.file": "File",
    "common.budget": "Budget",
    "common.work": "Work",
    "common.project": "Project",
    "common.value": "Value",
    "common.none": "None",
    "status.draft": "Draft",
    "status.sent": "Sent",
    "status.approved": "Approved",
    "status.rejected": "Rejected",
    "status.expired": "Expired",
    "status.waitingApproval": "Waiting approval",
    "status.ready": "Ready",
    "clientType.private": "Private",
    "clientType.company": "Company",
    "clientType.public": "Public",
    "clientType.other": "Other",
    "appShell.toggleNavigation": "Open navigation",
    "appShell.workspace": "Orzio workspace",
    "analytics.period.month": "Month",
    "analytics.period.quarter": "Quarter",
    "analytics.period.year": "Year",
    "analytics.previous.month": "vs previous month",
    "analytics.previous.quarter": "vs previous quarter",
    "analytics.previous.year": "vs previous year",
    "analytics.previous.yoy": "vs previous year",
    "analytics.delta.new": "new",
    "analytics.eyebrow": "Analytics",
    "analytics.title": "Dashboard",
    "analytics.description": "Analytical view of your budget portfolio.",
    "analytics.empty.title": "No budgets yet",
    "analytics.empty.description": "Create your first budget to start seeing metrics, charts, and portfolio comparisons.",
    "analytics.empty.cta": "Create budget",
    "analytics.error.stale": "Could not refresh the data. Showing the latest available information.",
    "analytics.kpi.generatedValue": "Generated value",
    "analytics.kpi.approvedValue": "Approved value",
    "analytics.kpi.conversionRate": "Conversion rate",
    "analytics.kpi.averageMargin": "Average margin",
    "analytics.alerts.title": "Actionable alerts",
    "analytics.alert.expiring.title": "Budgets expiring",
    "analytics.alert.expiring.desc": "Validity ends in the next 7 days",
    "analytics.alert.noResponse.title": "No response",
    "analytics.alert.noResponse.desc": "Sent more than 7 days ago with no reply",
    "analytics.alert.lowMargin.title": "Low margin",
    "analytics.alert.lowMargin.desc": "Open budgets below 15% margin",
    "analytics.alert.stale.title": "Stalled budgets",
    "analytics.alert.stale.desc": "Open with no activity for more than 14 days",
    "analytics.alerts.empty": "No alerts. Portfolio is up to date.",
    "analytics.chart.funnel": "Conversion funnel",
    "analytics.chart.evolution": "Budget evolution",
    "analytics.chart.evolutionHint": "last 6 months",
    "analytics.chart.margin": "Margin erosion",
    "analytics.chart.marginHint": "approved, top 8",
    "analytics.chart.typeSplit": "Projects vs Works",
    "analytics.chart.topClients": "Top clients",
    "analytics.chart.topClientsHint": "by generated value in the period",
    "analytics.chart.emptyPeriod": "No budgets in this period",
    "analytics.chart.emptyApproved": "No approved budgets in this period",
    "analytics.chart.emptyClients": "No identified clients in this period",
    "analytics.chart.budgetSingular": "budget",
    "analytics.chart.budgetPlural": "budgets",
    "analytics.chart.budgets": "Budgets",
    "analytics.chart.plannedMargin": "Planned margin",
    "analytics.chart.effectiveMargin": "Effective margin",
    "analytics.funnel.created": "Created",
    "analytics.funnel.sent": "Sent",
    "analytics.funnel.approved": "Approved",
    "analytics.type.projects": "Projects",
    "analytics.type.works": "Works",
    "analytics.stat.avgTicket": "Average ticket",
    "analytics.stat.salesCycle": "Sales cycle",
    "analytics.stat.days": "days",
    "analytics.stat.noData": "-",
    "analytics.stat.decidedApprox": "{count} decided budget{plural} / approximate",
    "analytics.stat.notEnoughData": "Not enough data in this period",
    "analytics.viewBudgets.title": "View all budgets",
    "analytics.viewBudgets.desc": "Full list, filters, and actions",
    "templates.eyebrow": "P0 library",
    "templates.title": "Templates to create a budget in minutes",
    "templates.description": "{validated} validated templates and {editable} editable bases generate a BudgetDraft with chapters, items, totals, and minimum margin.",
    "templates.search": "Search typology, discipline, or scope",
    "templates.filter.all": "All",
    "templates.filter.works": "Work",
    "templates.filter.projects": "Project",
    "templates.tab.validated": "Validated ({count})",
    "templates.tab.base": "Editable bases ({count})",
    "templates.maturity.validated": "Validated",
    "templates.maturity.validatedDesc": "Reviewed for a first budget with chapters, items, and margin.",
    "templates.maturity.baseEditable": "Editable base",
    "templates.maturity.baseEditableDesc": "Useful structure to adapt quantities, materials, and scope.",
    "templates.base": "Base",
    "templates.duration": "Duration",
    "templates.days": "days",
    "templates.risk": "Risk",
    "templates.margin": "Margin",
    "templates.includes": "Includes",
    "templates.viewDetail": "View detail",
    "templates.empty": "No template matches the active filters.",
    "templates.upgradeRequired": "Upgrade required",
    "templates.moduleNotIncluded": "This budget type is not included in the current plan.",
    "templates.limitReached": "You reached the active budget limit for the current plan.",
    "templates.created": "Budget created",
    "templates.createdDesc": "{title} is ready for editing.",
    "templates.createError": "Could not create the budget",
    "templates.discipline.residential": "Residential",
    "templates.discipline.commercial": "Commercial",
    "templates.discipline.healthcare": "Healthcare",
    "templates.discipline.hospitality": "Hospitality",
    "templates.discipline.industrial": "Industrial",
    "templates.discipline.public_space": "Public space",
    "templates.discipline.technical": "Technical",
    "templateDetail.validated.description": "Reviewed model to create a first budget with confidence.",
    "templateDetail.editable.description": "Initial structure to adapt quantities, brands, and scope.",
    "templateDetail.notFound": "Template not found",
    "templateDetail.notFoundDesc": "Return to the library and choose another template.",
    "templateDetail.back": "Back to templates",
    "templateDetail.work": "Work",
    "templateDetail.project": "Project",
    "templateDetail.risk": "Risk {value}%",
    "templateDetail.margin": "Margin {value}%",
    "templateDetail.baseTotal": "Base total",
    "templateDetail.chapters": "Chapters",
    "templateDetail.items": "Items",
    "templateDetail.duration": "Duration",
    "templateDetail.chapterBreakdown": "Chapter breakdown",
    "templateDetail.technicalAssumptions": "Technical assumptions",
    "templateDetail.assumption1": "Base values are subject to site visit, measurement, and technical validation.",
    "templateDetail.assumption2": "Quantities and brands must be adjusted before sending to the client.",
    "templateDetail.assumption3": "Minimum margin is preserved in the editor to avoid budgets below the risk threshold.",
    "templateDetail.recommendedFor": "Recommended for",
    "templateDetail.creating": "Creating...",
    "templateDetail.createFromTemplate": "Create budget from this template",
    "documents.eyebrow": "Document center",
    "documents.title": "Documents",
    "documents.description": "Preview and export PDFs from existing versions. Persistent download history will be enabled when the exports table is promoted.",
    "documents.stat.budgets": "Budgets",
    "documents.stat.ready": "Ready for document",
    "documents.stat.history": "History",
    "documents.history.title": "Document history",
    "documents.history.desc": "Record of completed previews/exports.",
    "documents.header.view": "View",
    "documents.header.created": "Created",
    "documents.view.internal": "Internal",
    "documents.view.client": "Client",
    "documents.empty.history": "No documents generated yet. Use the PDF button on a budget to create the first record.",
    "documents.search": "Search by work, client, type, or status",
    "documents.empty.budgets": "No budget found to generate a document.",
    "documents.loadError": "Error loading documents",
    "documents.loadErrorDesc": "Could not load the budget list.",
    "works.eyebrow": "Execution",
    "works.title": "Works",
    "works.description": "Approved work budgets appear here to generate execution plans, measurements, and certificates.",
    "works.stat.total": "Work budgets",
    "works.stat.approved": "Approved",
    "works.stat.pipeline": "Pipeline",
    "works.pipeline.ready": "Open execution and generate plan.",
    "works.pipeline.empty": "Approve a work budget to start.",
    "works.search": "Search work, client, or status",
    "works.execution": "Execution",
    "works.open": "Open work",
    "works.editor": "Editor",
    "works.empty": "No approved work yet. Approve a work budget to create execution.",
    "works.loadError": "Error loading works",
    "works.loadErrorDesc": "Could not load approved budgets.",
    "measurementAutos.title": "Measurement certificates",
    "measurementAutos.noPermission": "You do not have permission to issue or manage measurement certificates. An administrator can release this access in user permissions.",
    "measurementAutos.description": "Choose an approved work budget to open the measurement certificate page directly.",
    "measurementAutos.stat.ready": "Ready for certificate",
    "measurementAutos.stat.totalWorks": "Total works",
    "measurementAutos.stat.criteria": "Criteria",
    "measurementAutos.criteria": "Approved work budgets can generate certificates.",
    "measurementAutos.search": "Search budget, client, or type",
    "measurementAutos.autos": "Certificates",
    "measurementAutos.open": "Open certificates",
    "measurementAutos.empty": "No approved work budget found for measurement certificates.",
    "measurementAutos.loadError": "Error loading certificates",
    "measurementAutos.loadErrorDesc": "Could not load budgets ready for measurement certificates.",
    "revit.eyebrow": "BIM",
    "revit.title": "Import Revit Orzio Takeoff",
    "revit.description": "Import the .xlsx sheet generated in Revit by the Orzio Takeoff add-in and continue pricing in the budget assistant.",
    "revit.selectFile": "Select sheet",
    "revit.continueBudget": "Continue budget",
    "revit.input": "Input",
    "revit.file": "File",
    "revit.noFile": "No sheet selected",
    "revit.budgetName": "Budget name",
    "revit.budgetNamePlaceholder": "E.g.: Orzio Takeoff - Block A",
    "revit.preview": "Preview",
    "revit.previewDesc": "Items enter without unit price for review before saving the budget.",
    "revit.rows": "{count} rows",
    "revit.model": "Model",
    "revit.phase": "Phase",
    "revit.toDefine": "To define",
    "revit.extracted": "Extracted",
    "revit.quantity": "Quantity",
    "revit.item": "Item",
    "revit.countInUnit": "{count} in {unit}",
    "revit.emptyPreview": "Select the Orzio Takeoff .xlsx sheet to view quantities.",
    "revit.imported": "Sheet imported",
    "revit.importedDesc": "{count} quantity rows are ready for review.",
    "revit.importFailed": "Revit import failed",
    "revit.readError": "Could not read the sheet generated by Orzio Takeoff.",
    "revit.noDate": "No date",
    "bim.title": "IFC import with a model-oriented flow",
    "bim.description": "Import the IFC model first, review extracted elements, then choose whether to create a new budget or link it to an existing one.",
    "bim.currentState": "Current state",
    "bim.workflow.importado.label": "Import IFC",
    "bim.workflow.importado.description": "Upload an IFC model to review extracted elements.",
    "bim.workflow.importado.cta": "Import IFC",
    "bim.workflow.destino.label": "Choose destination",
    "bim.workflow.destino.description": "Import extracted and waiting for a destination budget.",
    "bim.workflow.destino.cta": "Choose destination",
    "bim.workflow.mapeado.label": "Map compositions",
    "bim.workflow.mapeado.description": "Link compositions to extracted elements before calculating items.",
    "bim.workflow.mapeado.cta": "Map compositions",
    "bim.workflow.calculado.label": "Calculate items",
    "bim.workflow.calculado.description": "Mapped compositions can generate calculated items.",
    "bim.workflow.calculado.cta": "Calculate items",
    "bim.workflow.editor.label": "Open editor",
    "bim.workflow.editor.description": "IFC items are ready for review in the editor.",
    "bim.workflow.editor.cta": "Open editor",
    "bim.metric.extracted": "Extracted elements",
    "bim.metric.mapped": "Mapped elements",
    "bim.metric.calculated": "Calculated items",
    "bim.destination.title": "Import destination",
    "bim.destination.empty": "Import an IFC to choose the destination.",
    "bim.destination.pending": "Import waiting for destination",
    "bim.createFromIfc.title": "Create new budget from this IFC",
    "bim.createFromIfc.desc": "Use extracted elements to start a new technical budget.",
    "bim.createFromIfc.button": "Create new budget",
    "bim.associate.title": "Link to existing budget",
    "bim.associate.desc": "Link this model to an existing budget and continue mapping.",
    "bim.associate.search": "Search by name, client, or status",
    "bim.associate.button": "Link to this budget",
    "bim.associateManual.title": "Manual association by ID",
    "bim.associateManual.desc": "Use only if you know the exact technical budget identifier.",
    "bim.associateManual.placeholder": "Technical budget ID",
    "bim.associateManual.button": "Link",
    "bim.associatedTo": "Linked to",
    "bim.refreshState": "Refresh state",
    "bim.mapping.title": "Mapping and calculation",
    "bim.mapping.desc": "Mapping becomes available after choosing a destination budget.",
    "bim.mapping.needDestination": "Choose a destination budget before mapping compositions.",
    "bim.calculate": "Calculate items",
    "bim.openEditor": "Open editor",
    "bim.calculated.title": "IFC items calculated",
    "bim.calculated.desc": "{count} items prepared for review in the editor.",
    "bim.history.title": "BIM/IFC history",
    "bim.history.versions": "Model versions",
    "bim.history.noVersions": "No IFC versions registered for this budget yet.",
    "bim.history.version": "Version {number}",
    "bim.history.current": "Current",
    "bim.history.model": "IFC model",
    "bim.history.elements": "elements",
    "bim.history.comparisons": "Comparisons",
    "bim.history.noComparisons": "No IFC comparison generated yet.",
    "bim.history.changesTitle": "Changes found in the new IFC",
    "bim.history.changesSummary": "{added} added / {removed} removed / {changed} changed / {uncertain} uncertain",
    "bim.error.loadElements": "Could not load IFC elements",
    "bim.error.loadElementsDesc": "The IFC file was imported, but elements could not be loaded yet.",
    "bim.toast.imported": "IFC imported successfully",
    "bim.toast.importedWithBudget": "{count} elements were extracted and linked to the selected budget.",
    "bim.toast.importedNoBudget": "{count} elements were extracted. Choose the destination now.",
    "bim.error.saveImport": "Could not save the IFC import",
    "bim.error.saveImportDesc": "Check the IFC file and try again.",
    "bim.toast.modelAssociated": "Model linked",
    "bim.toast.modelAssociatedDesc": "You can now map compositions and calculate items.",
    "bim.error.associate": "Could not link the IFC to the budget",
    "bim.error.retrySoon": "Try again shortly.",
    "bim.error.createBudget": "Could not create budget from IFC",
    "bim.error.mapComposition": "Could not map the composition",
    "bim.error.selectDestination": "Choose a destination budget before calculating items.",
    "bim.error.mapBeforeCalculate": "Map compositions before calculating items.",
    "bim.error.mapBeforeCalculateDesc": "Review extracted elements and link compositions in the table.",
    "bim.error.noCalculable": "No calculable quantities",
    "bim.error.noCalculableDesc": "Review elements with quantities before calculating items.",
    "bim.toast.linesCalculated": "Items calculated",
    "bim.toast.linesCalculatedDesc": "{count} IFC items are ready for review.",
    "contacts.eyebrow": "Commercial directory",
    "contacts.title": "Contacts",
    "contacts.description": "Structured clients to link to budgets, review history, and avoid duplicate free-text names.",
    "contacts.new": "New contact",
    "contacts.stat.total": "Contacts",
    "contacts.stat.withBudgets": "With budgets",
    "contacts.stat.pipeline": "Associated pipeline",
    "contacts.search": "Search by name, tax ID, email, phone, or notes",
    "contacts.allTypes": "All types",
    "contacts.actionsFor": "Actions for {name}",
    "contacts.edit": "Edit contact",
    "contacts.delete": "Delete contact",
    "contacts.budgets": "Budgets",
    "contacts.approved": "Approved",
    "contacts.lastBudget": "Last budget:",
    "contacts.noHistory": "no history",
    "contacts.viewBudgets": "View budgets",
    "contacts.empty": "No contact found. Create the first client or adjust filters.",
    "contacts.dialog.editTitle": "Edit contact",
    "contacts.dialog.newTitle": "New contact",
    "contacts.dialog.editDesc": "Update the structured data for this contact.",
    "contacts.dialog.newDesc": "This client will be available in the editor selector and commercial history.",
    "contacts.form.name": "Name",
    "contacts.form.namePlaceholder": "Client or company name",
    "contacts.form.tax": "Tax ID",
    "contacts.form.email": "Email",
    "contacts.form.phone": "Phone",
    "contacts.form.address": "Address",
    "contacts.form.notes": "Notes",
    "contacts.form.notesPlaceholder": "Preferences, commercial context, or internal notes",
    "contacts.saveChanges": "Save changes",
    "contacts.create": "Create contact",
    "contacts.nameRequired": "Name required",
    "contacts.nameRequiredDesc": "Enter the client name before saving.",
    "contacts.updated": "Contact updated",
    "contacts.created": "Client created",
    "contacts.deleted": "Contact deleted",
    "contacts.createError": "Could not create the client",
    "contacts.updateError": "Could not update the contact",
    "contacts.deleteError": "Could not delete the contact",
    "contacts.loadError": "Error loading contacts",
    "contacts.loadErrorDesc": "Could not load clients.",
    "contacts.deleteTitle": "Delete contact?",
    "contacts.deleteDesc": "This action removes the contact \"{name}\". Associated budgets will no longer have this contact selected.",
    "contacts.deleting": "Deleting...",
    "clientSelect.private": "Private",
    "clientSelect.company": "Company",
    "clientSelect.public": "Public entity",
    "clientSelect.other": "Other",
    "clientSelect.placeholder": "Select client",
    "clientSelect.search": "Search client...",
    "clientSelect.loading": "Loading clients",
    "clientSelect.empty": "No client found.",
    "clientSelect.remove": "Remove client",
    "clientSelect.create": "Create client",
    "clientSelect.namePlaceholder": "Client name",
    "clientSelect.createAria": "Create client",
    "clientSelect.updateError": "Could not update the client.",
    "editor.backToBudgets": "Back to budgets",
    "editor.budgetTrail": "Budgets /",
    "editor.referenceAria": "Budget reference",
    "editor.clientAria": "Client",
    "editor.clientPlaceholder": "Client not set",
    "editor.save.idle": "No changes",
    "editor.save.saving": "Saving...",
    "editor.save.saved": "Saved",
    "editor.save.error": "Save error",
    "editor.saveButton.saving": "Saving",
    "editor.saveButton": "Save",
    "editor.export": "Export",
    "editor.createWork": "Create work",
    "editor.approve": "Approve",
    "editor.moreActions": "More actions",
    "editor.duplicate": "Duplicate budget",
    "editor.newVersion": "New version",
    "editor.versionHistory": "Version history",
    "editor.execution": "Execution and measurement",
    "editor.importIfc": "Import IFC",
    "permissions.budgets.view": "View budgets",
    "permissions.budgets.create": "Create budgets",
    "permissions.budgets.edit": "Edit budgets",
    "permissions.budgets.delete": "Delete budgets",
    "permissions.cost_bases.view": "View cost database",
    "permissions.cost_bases.edit": "Edit cost database",
    "permissions.cost_bases.delete": "Delete cost database",
    "permissions.team.manage": "Manage team",
    "permissions.admin.access": "Access administrative areas",
    "costDatabase.resource.count": "{count} resource{plural}",
    "costDatabase.resource.new": "New resource",
    "costDatabase.resource.empty": "No resource created yet. Create the first one to start building compositions.",
    "costDatabase.resource.name": "Name",
    "costDatabase.resource.category": "Category",
    "costDatabase.resource.unit": "Unit",
    "costDatabase.resource.price": "Price",
    "costDatabase.resource.edit": "Edit",
    "costDatabase.resource.delete": "Delete",
    "costDatabase.resource.editTitle": "Edit resource",
    "costDatabase.resource.newTitle": "New resource",
    "costDatabase.resource.updated": "Resource updated",
    "costDatabase.resource.created": "Resource created",
    "costDatabase.resource.form.name": "Name",
    "costDatabase.resource.form.namePlaceholder": "Ceramic block 30x20x11",
    "costDatabase.resource.form.category": "Category",
    "costDatabase.resource.form.unit": "Unit",
    "costDatabase.resource.form.basePrice": "Base price (EUR)",
    "costDatabase.resource.form.priceSource": "Price source",
    "costDatabase.resource.form.selectSource": "Select source",
    "costDatabase.resource.form.noSource": "No source",
    "costDatabase.resource.form.referenceDate": "Reference date",
    "costDatabase.resource.form.notes": "Notes",
    "costDatabase.resource.form.notesPlaceholder": "Optional notes",
    "costDatabase.resource.form.checkingBenchmark": "Checking market reference...",
    "costDatabase.resource.form.accountReference": "Your account reference:",
    "costDatabase.resource.form.globalReference": "Global reference:",
    "costDatabase.resource.form.ownObservations": "{count} own observation(s)",
    "costDatabase.resource.form.anonymousObservations": "{count} anonymous observation(s)",
    "costDatabase.resource.form.use": "Use",
    "costDatabase.resource.form.aboveReference": "Value is {value}% above the reference.",
    "costDatabase.resource.form.belowReference": "Value is {value}% below the reference.",
    "costDatabase.resource.form.globalMean": "Global mean:",
    "costDatabase.resource.form.globalMedian": "Global median:",
    "costDatabase.resource.form.noBenchmark": "Not enough reference data for this resource and unit.",
    "costDatabase.resource.form.create": "Create resource",
    "costDatabase.resource.category.material": "Material",
    "costDatabase.resource.category.labor": "Labor",
    "costDatabase.resource.category.equipment": "Equipment",
    "costDatabase.resource.category.subcontract": "Subcontract",
    "costDatabase.resource.category.other": "Other",
    "costDatabase.dataTier.official": "Official",
    "costDatabase.dataTier.scraped": "Scraped",
    "costDatabase.dataTier.user_edited": "User edited",
    "costDatabase.dataTier.ai_derived": "AI",
    "import.status.pending": "Pending",
    "import.status.processing": "Processing",
    "import.status.review": "In review",
    "import.status.completed": "Completed",
    "import.status.failed": "Failed",
    "costDatabase.composition.count": "{count} composition{plural}",
    "costDatabase.composition.new": "New composition",
    "costDatabase.composition.empty": "No composition created yet. Compositions group resources into budgetable work items.",
    "costDatabase.composition.resourcesRequired": "Create resources first. A composition needs at least one resource.",
    "costDatabase.composition.editTitle": "Edit composition",
    "costDatabase.composition.newTitle": "New composition",
    "costDatabase.composition.updated": "Composition updated",
    "costDatabase.composition.created": "Composition created",
    "costDatabase.composition.status.active": "Active",
    "costDatabase.composition.status.draft": "Draft",
    "costDatabase.composition.status.archived": "Archived",
    "costDatabase.composition.form.code": "Code",
    "costDatabase.composition.form.unit": "Unit",
    "costDatabase.composition.form.name": "Name",
    "costDatabase.composition.form.namePlaceholder": "Interior ceramic block wall e/30",
    "costDatabase.composition.form.description": "Description",
    "costDatabase.composition.form.descriptionPlaceholder": "Technical specifications, execution notes...",
    "costDatabase.composition.form.workCategory": "Work category",
    "costDatabase.composition.form.noCategory": "No category",
    "costDatabase.composition.form.discipline": "Discipline",
    "costDatabase.composition.form.noDiscipline": "No discipline",
    "costDatabase.composition.form.status": "Status",
    "costDatabase.composition.form.selectPlaceholder": "Select...",
    "costDatabase.composition.form.saveEdit": "Save changes",
    "costDatabase.composition.form.saveCreate": "Create composition",
    "costDatabase.compositionItem.resource": "Resource",
    "costDatabase.compositionItem.quantity": "Qty/unit",
    "costDatabase.compositionItem.waste": "Waste %",
    "costDatabase.compositionItem.unitPrice": "Unit price",
    "costDatabase.compositionItem.totalUnitCost": "Total unit cost:",
    "costDatabase.compositionItem.addResource": "Add resource",
    "costDatabase.compositionItem.selectResource": "Select resource...",
    "costDatabase.compositionItem.allResourcesAdded": "All resources already added",
    "costDatabase.compositionItem.add": "Add",
    "import.upload.currencyRequired": "Currency is required",
    "import.edit.title": "Edit import",
    "import.edit.description": "Adjust this imported database metadata without uploading the file again.",
    "import.edit.save": "Save changes",
    "import.delete.title": "Delete import",
    "import.delete.description": "This will delete the import \"{name}\". Staged rows, mappings and associated conflicts will be removed. Data already promoted to the main database is not deleted automatically.",
    "import.delete.descriptionFallback": "This will delete this import. Staged rows, mappings and associated conflicts will be removed. Data already promoted to the main database is not deleted automatically.",
    "import.updated": "Import updated",
    "import.deleted": "Import deleted",
    "import.fileType.title": "Choose file type",
    "import.fileType.description": "Select the database format first. The matching import panel appears below.",
    "import.fileType.bc3.description": "Structured chapters, compositions and resources.",
    "import.fileType.xlsx.description": "Cost spreadsheets and tabular catalogs.",
    "import.fileType.json.description": "Load from an external collector or integration.",
    "import.jobs.count": "{count} import job{plural} (BC3, XLSX, JSON...)"
  },
  es: {
    "common.actions": "Acciones",
    "common.action": "Accion",
    "common.refresh": "Actualizar",
    "common.open": "Abrir",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.create": "Crear",
    "common.creating": "Creando...",
    "common.saving": "Guardando...",
    "common.search": "Buscar",
    "common.client": "Cliente",
    "common.noClient": "Sin cliente",
    "common.status": "Estado",
    "common.updated": "Actualizado",
    "common.total": "Total",
    "common.price": "Precio",
    "common.unit": "Unidad",
    "common.category": "Categoria",
    "common.file": "Fichero",
    "common.budget": "Presupuesto",
    "common.work": "Obra",
    "common.project": "Proyecto",
    "common.value": "Valor",
    "common.none": "Ninguno",
    "status.draft": "Borrador",
    "status.sent": "Enviado",
    "status.approved": "Aprobado",
    "status.rejected": "Rechazado",
    "status.expired": "Expirado",
    "status.waitingApproval": "Esperando aprobacion",
    "status.ready": "Apto",
    "clientType.private": "Particular",
    "clientType.company": "Empresa",
    "clientType.public": "Publico",
    "clientType.other": "Otro",
    "appShell.toggleNavigation": "Abrir navegacion",
    "appShell.workspace": "Workspace Orzio",
    "analytics.period.month": "Mes",
    "analytics.period.quarter": "Trimestre",
    "analytics.period.year": "Ano",
    "analytics.previous.month": "vs mes anterior",
    "analytics.previous.quarter": "vs trimestre anterior",
    "analytics.previous.year": "vs ano anterior",
    "analytics.previous.yoy": "vs ano anterior",
    "analytics.delta.new": "nuevo",
    "analytics.eyebrow": "Analisis",
    "analytics.title": "Dashboard",
    "analytics.description": "Vista analitica de su cartera de presupuestos.",
    "analytics.empty.title": "Aun no hay presupuestos",
    "analytics.empty.description": "Cree su primer presupuesto para empezar a ver metricas, graficos y comparativas de cartera.",
    "analytics.empty.cta": "Crear presupuesto",
    "analytics.error.stale": "No fue posible actualizar los datos. Se muestra la ultima informacion disponible.",
    "analytics.kpi.generatedValue": "Valor generado",
    "analytics.kpi.approvedValue": "Valor aprobado",
    "analytics.kpi.conversionRate": "Tasa de conversion",
    "analytics.kpi.averageMargin": "Margen medio",
    "analytics.alerts.title": "Alertas accionables",
    "analytics.alert.expiring.title": "Presupuestos por expirar",
    "analytics.alert.expiring.desc": "La validez termina en los proximos 7 dias",
    "analytics.alert.noResponse.title": "Sin respuesta",
    "analytics.alert.noResponse.desc": "Enviados hace mas de 7 dias sin retorno",
    "analytics.alert.lowMargin.title": "Margen bajo",
    "analytics.alert.lowMargin.desc": "Presupuestos abiertos por debajo del 15% de margen",
    "analytics.alert.stale.title": "Presupuestos parados",
    "analytics.alert.stale.desc": "Abiertos sin actividad desde hace mas de 14 dias",
    "analytics.alerts.empty": "Sin alertas. Cartera al dia.",
    "analytics.chart.funnel": "Embudo de conversion",
    "analytics.chart.evolution": "Evolucion de presupuestos",
    "analytics.chart.evolutionHint": "ultimos 6 meses",
    "analytics.chart.margin": "Erosion de margen",
    "analytics.chart.marginHint": "aprobados, top 8",
    "analytics.chart.typeSplit": "Proyectos vs Obras",
    "analytics.chart.topClients": "Top clientes",
    "analytics.chart.topClientsHint": "por valor generado en el periodo",
    "analytics.chart.emptyPeriod": "Sin presupuestos en el periodo",
    "analytics.chart.emptyApproved": "Sin presupuestos aprobados en el periodo",
    "analytics.chart.emptyClients": "Sin clientes identificados en el periodo",
    "analytics.chart.budgetSingular": "presupuesto",
    "analytics.chart.budgetPlural": "presupuestos",
    "analytics.chart.budgets": "Presupuestos",
    "analytics.chart.plannedMargin": "Margen planificado",
    "analytics.chart.effectiveMargin": "Margen efectivo",
    "analytics.funnel.created": "Creados",
    "analytics.funnel.sent": "Enviados",
    "analytics.funnel.approved": "Aprobados",
    "analytics.type.projects": "Proyectos",
    "analytics.type.works": "Obras",
    "analytics.stat.avgTicket": "Ticket medio",
    "analytics.stat.salesCycle": "Ciclo de venta",
    "analytics.stat.days": "dias",
    "analytics.stat.noData": "-",
    "analytics.stat.decidedApprox": "{count} presupuesto{plural} decidido{plural} / aproximado",
    "analytics.stat.notEnoughData": "Sin datos suficientes en el periodo",
    "analytics.viewBudgets.title": "Ver todos los presupuestos",
    "analytics.viewBudgets.desc": "Lista completa, filtros y acciones",
    "templates.eyebrow": "Biblioteca P0",
    "templates.title": "Modelos para crear un presupuesto en minutos",
    "templates.description": "{validated} modelos validados y {editable} bases editables generan un BudgetDraft con capitulos, partidas, totales y margen minimo.",
    "templates.search": "Buscar tipologia, disciplina o alcance",
    "templates.filter.all": "Todos",
    "templates.filter.works": "Obra",
    "templates.filter.projects": "Proyecto",
    "templates.tab.validated": "Validados ({count})",
    "templates.tab.base": "Bases editables ({count})",
    "templates.maturity.validated": "Validado",
    "templates.maturity.validatedDesc": "Revisado para un primer presupuesto con capitulos, partidas y margen.",
    "templates.maturity.baseEditable": "Base editable",
    "templates.maturity.baseEditableDesc": "Estructura util para adaptar cantidades, materiales y alcance.",
    "templates.base": "Base",
    "templates.duration": "Plazo",
    "templates.days": "dias",
    "templates.risk": "Riesgo",
    "templates.margin": "Margen",
    "templates.includes": "Incluye",
    "templates.viewDetail": "Ver detalle",
    "templates.empty": "Ningun modelo coincide con los filtros activos.",
    "templates.upgradeRequired": "Upgrade necesario",
    "templates.moduleNotIncluded": "Este tipo de presupuesto no esta incluido en el plan actual.",
    "templates.limitReached": "Ha alcanzado el limite de presupuestos activos del plan actual.",
    "templates.created": "Presupuesto creado",
    "templates.createdDesc": "{title} esta listo para edicion.",
    "templates.createError": "No fue posible crear el presupuesto",
    "templates.discipline.residential": "Residencial",
    "templates.discipline.commercial": "Comercial",
    "templates.discipline.healthcare": "Salud",
    "templates.discipline.hospitality": "Hosteleria",
    "templates.discipline.industrial": "Industrial",
    "templates.discipline.public_space": "Espacio publico",
    "templates.discipline.technical": "Tecnico",
    "templateDetail.validated.description": "Modelo revisado para crear un primer presupuesto con confianza.",
    "templateDetail.editable.description": "Estructura inicial para adaptar cantidades, marcas y alcance.",
    "templateDetail.notFound": "Modelo no encontrado",
    "templateDetail.notFoundDesc": "Vuelva a la biblioteca y elija otro modelo.",
    "templateDetail.back": "Volver a modelos",
    "templateDetail.work": "Obra",
    "templateDetail.project": "Proyecto",
    "templateDetail.risk": "Riesgo {value}%",
    "templateDetail.margin": "Margen {value}%",
    "templateDetail.baseTotal": "Total base",
    "templateDetail.chapters": "Capitulos",
    "templateDetail.items": "Partidas",
    "templateDetail.duration": "Plazo",
    "templateDetail.chapterBreakdown": "Desglose por capitulos",
    "templateDetail.technicalAssumptions": "Premisas tecnicas",
    "templateDetail.assumption1": "Valores base sujetos a visita, medicion y validacion tecnica.",
    "templateDetail.assumption2": "Cantidades y marcas deben ajustarse antes de enviar al cliente.",
    "templateDetail.assumption3": "Margen minimo preservado en el editor para evitar presupuestos por debajo del riesgo.",
    "templateDetail.recommendedFor": "Recomendado para",
    "templateDetail.creating": "Creando...",
    "templateDetail.createFromTemplate": "Crear presupuesto desde este modelo",
    "documents.eyebrow": "Centro documental",
    "documents.title": "Documentos",
    "documents.description": "Previsualice y exporte PDFs desde versiones existentes. El historial persistente de descargas se activara cuando se promueva la tabla de exportaciones.",
    "documents.stat.budgets": "Presupuestos",
    "documents.stat.ready": "Listos para documento",
    "documents.stat.history": "Historial",
    "documents.history.title": "Historial de documentos",
    "documents.history.desc": "Registro de previsualizaciones/exportaciones completadas.",
    "documents.header.view": "Vista",
    "documents.header.created": "Creado",
    "documents.view.internal": "Interna",
    "documents.view.client": "Cliente",
    "documents.empty.history": "Aun no existen documentos generados. Use el boton PDF en un presupuesto para crear el primer registro.",
    "documents.search": "Buscar por obra, cliente, tipo o estado",
    "documents.empty.budgets": "No se encontro ningun presupuesto para generar documento.",
    "documents.loadError": "Error al cargar documentos",
    "documents.loadErrorDesc": "No fue posible cargar la lista de presupuestos.",
    "works.eyebrow": "Ejecucion",
    "works.title": "Obras",
    "works.description": "Los presupuestos de obra aprobados aparecen aqui para generar plan de ejecucion, mediciones y certificaciones.",
    "works.stat.total": "Presupuestos de obra",
    "works.stat.approved": "Aprobados",
    "works.stat.pipeline": "Pipeline",
    "works.pipeline.ready": "Abrir ejecucion y generar plan.",
    "works.pipeline.empty": "Apruebe un presupuesto de obra para empezar.",
    "works.search": "Buscar obra, cliente o estado",
    "works.execution": "Ejecucion",
    "works.open": "Abrir obra",
    "works.editor": "Editor",
    "works.empty": "No hay obras aprobadas todavia. Apruebe un presupuesto de obra para crear la ejecucion.",
    "works.loadError": "Error al cargar obras",
    "works.loadErrorDesc": "No fue posible cargar los presupuestos aprobados.",
    "measurementAutos.title": "Certificaciones de medicion",
    "measurementAutos.noPermission": "No tiene permiso para emitir o gestionar certificaciones de medicion. Un administrador puede habilitar este acceso en los permisos del usuario.",
    "measurementAutos.description": "Seleccione un presupuesto de obra aprobado para abrir directamente la pagina de certificaciones de medicion.",
    "measurementAutos.stat.ready": "Aptos para certificado",
    "measurementAutos.stat.totalWorks": "Total de obras",
    "measurementAutos.stat.criteria": "Criterio",
    "measurementAutos.criteria": "Los presupuestos de obra aprobados pueden generar certificaciones.",
    "measurementAutos.search": "Buscar presupuesto, cliente o tipo",
    "measurementAutos.autos": "Certificados",
    "measurementAutos.open": "Abrir certificados",
    "measurementAutos.empty": "No se encontro ningun presupuesto de obra aprobado para certificaciones.",
    "measurementAutos.loadError": "Error al cargar certificados",
    "measurementAutos.loadErrorDesc": "No fue posible cargar presupuestos aptos para certificaciones de medicion.",
    "revit.eyebrow": "BIM",
    "revit.title": "Importar Revit Orzio Takeoff",
    "revit.description": "Importe la hoja .xlsx generada en Revit por el add-in Orzio Takeoff y continue el presupuesto en el asistente.",
    "revit.selectFile": "Seleccionar hoja",
    "revit.continueBudget": "Continuar presupuesto",
    "revit.input": "Entrada",
    "revit.file": "Archivo",
    "revit.noFile": "Ninguna hoja seleccionada",
    "revit.budgetName": "Nombre del presupuesto",
    "revit.budgetNamePlaceholder": "Ej.: Orzio Takeoff - Bloque A",
    "revit.preview": "Previsualizacion",
    "revit.previewDesc": "Las partidas entran sin precio unitario para revision antes de guardar el presupuesto.",
    "revit.rows": "{count} filas",
    "revit.model": "Modelo",
    "revit.phase": "Fase",
    "revit.toDefine": "Por definir",
    "revit.extracted": "Extraido",
    "revit.quantity": "Cantidad",
    "revit.item": "Partida",
    "revit.countInUnit": "{count} en {unit}",
    "revit.emptyPreview": "Seleccione la hoja .xlsx de Orzio Takeoff para ver los cuantitativos.",
    "revit.imported": "Hoja importada",
    "revit.importedDesc": "{count} lineas de cuantitativos listas para revision.",
    "revit.importFailed": "Importacion Revit fallida",
    "revit.readError": "No fue posible leer la hoja generada por Orzio Takeoff.",
    "revit.noDate": "Sin fecha",
    "bim.title": "Importacion IFC con flujo orientado al modelo",
    "bim.description": "Importe primero el modelo IFC, revise los elementos extraidos y despues elija si crea un nuevo presupuesto o lo asocia a uno existente.",
    "bim.currentState": "Estado actual",
    "bim.workflow.importado.label": "Importar IFC",
    "bim.workflow.importado.description": "Cargue un modelo IFC para revisar los elementos extraidos.",
    "bim.workflow.importado.cta": "Importar IFC",
    "bim.workflow.destino.label": "Escoger destino",
    "bim.workflow.destino.description": "Importacion extraida y pendiente de presupuesto de destino.",
    "bim.workflow.destino.cta": "Escoger destino",
    "bim.workflow.mapeado.label": "Mapear composiciones",
    "bim.workflow.mapeado.description": "Asocie composiciones a los elementos extraidos antes de calcular partidas.",
    "bim.workflow.mapeado.cta": "Mapear composiciones",
    "bim.workflow.calculado.label": "Calcular partidas",
    "bim.workflow.calculado.description": "Las composiciones mapeadas pueden generar partidas calculadas.",
    "bim.workflow.calculado.cta": "Calcular partidas",
    "bim.workflow.editor.label": "Abrir editor",
    "bim.workflow.editor.description": "Las partidas IFC estan listas para revision en el editor.",
    "bim.workflow.editor.cta": "Abrir editor",
    "bim.metric.extracted": "Elementos extraidos",
    "bim.metric.mapped": "Elementos mapeados",
    "bim.metric.calculated": "Partidas calculadas",
    "bim.destination.title": "Destino de la importacion",
    "bim.destination.empty": "Importe un IFC para escoger el destino.",
    "bim.destination.pending": "Importacion pendiente de destino",
    "bim.createFromIfc.title": "Crear nuevo presupuesto desde este IFC",
    "bim.createFromIfc.desc": "Use los elementos extraidos para iniciar un nuevo presupuesto tecnico.",
    "bim.createFromIfc.button": "Crear nuevo presupuesto",
    "bim.associate.title": "Asociar a presupuesto existente",
    "bim.associate.desc": "Vincule este modelo a un presupuesto ya creado y continue el mapeo.",
    "bim.associate.search": "Buscar por nombre, cliente o estado",
    "bim.associate.button": "Asociar a este presupuesto",
    "bim.associateManual.title": "Asociacion manual por ID",
    "bim.associateManual.desc": "Use solo si conoce exactamente el identificador tecnico del presupuesto.",
    "bim.associateManual.placeholder": "ID tecnico del presupuesto",
    "bim.associateManual.button": "Asociar",
    "bim.associatedTo": "Asociado a",
    "bim.refreshState": "Actualizar estado",
    "bim.mapping.title": "Mapeo y calculo",
    "bim.mapping.desc": "El mapeo queda disponible despues de escoger un presupuesto de destino.",
    "bim.mapping.needDestination": "Escoja un presupuesto de destino antes de mapear composiciones.",
    "bim.calculate": "Calcular partidas",
    "bim.openEditor": "Abrir editor",
    "bim.calculated.title": "Partidas IFC calculadas",
    "bim.calculated.desc": "{count} partidas preparadas para revision en el editor.",
    "bim.history.title": "Historial BIM/IFC",
    "bim.history.versions": "Versiones del modelo",
    "bim.history.noVersions": "Todavia no hay versiones IFC registradas para este presupuesto.",
    "bim.history.version": "Version {number}",
    "bim.history.current": "Actual",
    "bim.history.model": "Modelo IFC",
    "bim.history.elements": "elementos",
    "bim.history.comparisons": "Comparaciones",
    "bim.history.noComparisons": "Todavia no se genero ninguna comparacion IFC.",
    "bim.history.changesTitle": "Cambios encontrados en el nuevo IFC",
    "bim.history.changesSummary": "{added} agregados / {removed} eliminados / {changed} modificados / {uncertain} inciertos",
    "bim.error.loadElements": "No fue posible cargar elementos IFC",
    "bim.error.loadElementsDesc": "El fichero IFC fue importado, pero los elementos aun no pudieron cargarse.",
    "bim.toast.imported": "IFC importado con exito",
    "bim.toast.importedWithBudget": "{count} elementos fueron extraidos y asociados al presupuesto seleccionado.",
    "bim.toast.importedNoBudget": "{count} elementos fueron extraidos. Escoja ahora el destino.",
    "bim.error.saveImport": "No fue posible guardar la importacion IFC",
    "bim.error.saveImportDesc": "Verifique el fichero IFC e intentelo de nuevo.",
    "bim.toast.modelAssociated": "Modelo asociado",
    "bim.toast.modelAssociatedDesc": "Ya puede mapear composiciones y calcular partidas.",
    "bim.error.associate": "No fue posible asociar el IFC al presupuesto",
    "bim.error.retrySoon": "Intentelo de nuevo en unos instantes.",
    "bim.error.createBudget": "No fue posible crear presupuesto desde el IFC",
    "bim.error.mapComposition": "No fue posible mapear la composicion",
    "bim.error.selectDestination": "Escoja un presupuesto de destino antes de calcular partidas.",
    "bim.error.mapBeforeCalculate": "Mapee composiciones antes de calcular partidas.",
    "bim.error.mapBeforeCalculateDesc": "Puede revisar los elementos extraidos y asociar composiciones en la tabla.",
    "bim.error.noCalculable": "Sin cantidades calculables",
    "bim.error.noCalculableDesc": "Revise elementos con cantidades antes de calcular partidas.",
    "bim.toast.linesCalculated": "Partidas calculadas",
    "bim.toast.linesCalculatedDesc": "{count} partidas IFC listas para revision.",
    "contacts.eyebrow": "Directorio comercial",
    "contacts.title": "Contactos",
    "contacts.description": "Clientes estructurados para asociar a presupuestos, consultar historico y evitar nombres duplicados en texto libre.",
    "contacts.new": "Nuevo contacto",
    "contacts.stat.total": "Contactos",
    "contacts.stat.withBudgets": "Con presupuestos",
    "contacts.stat.pipeline": "Pipeline asociado",
    "contacts.search": "Buscar por nombre, NIF, email, telefono o notas",
    "contacts.allTypes": "Todos los tipos",
    "contacts.actionsFor": "Acciones de {name}",
    "contacts.edit": "Editar contacto",
    "contacts.delete": "Eliminar contacto",
    "contacts.budgets": "Presupuestos",
    "contacts.approved": "Aprobados",
    "contacts.lastBudget": "Ultimo presupuesto:",
    "contacts.noHistory": "sin historico",
    "contacts.viewBudgets": "Ver presupuestos",
    "contacts.empty": "Ningun contacto encontrado. Cree el primer cliente o ajuste los filtros.",
    "contacts.dialog.editTitle": "Editar contacto",
    "contacts.dialog.newTitle": "Nuevo contacto",
    "contacts.dialog.editDesc": "Actualice los datos estructurados de este contacto.",
    "contacts.dialog.newDesc": "Este cliente quedara disponible en el selector del editor y en el historico comercial.",
    "contacts.form.name": "Nombre",
    "contacts.form.namePlaceholder": "Nombre del cliente o empresa",
    "contacts.form.tax": "NIF/NIPC",
    "contacts.form.email": "Email",
    "contacts.form.phone": "Telefono",
    "contacts.form.address": "Direccion",
    "contacts.form.notes": "Notas",
    "contacts.form.notesPlaceholder": "Preferencias, contexto comercial u observaciones internas",
    "contacts.saveChanges": "Guardar cambios",
    "contacts.create": "Crear contacto",
    "contacts.nameRequired": "Nombre obligatorio",
    "contacts.nameRequiredDesc": "Indique el nombre del cliente antes de guardar.",
    "contacts.updated": "Contacto actualizado",
    "contacts.created": "Cliente creado",
    "contacts.deleted": "Contacto eliminado",
    "contacts.createError": "No fue posible crear el cliente",
    "contacts.updateError": "No fue posible actualizar el contacto",
    "contacts.deleteError": "No fue posible eliminar el contacto",
    "contacts.loadError": "Error al cargar contactos",
    "contacts.loadErrorDesc": "No fue posible cargar los clientes.",
    "contacts.deleteTitle": "Eliminar contacto?",
    "contacts.deleteDesc": "Esta accion elimina el contacto \"{name}\". Los presupuestos asociados dejaran de tener este contacto seleccionado.",
    "contacts.deleting": "Eliminando...",
    "clientSelect.private": "Particular",
    "clientSelect.company": "Empresa",
    "clientSelect.public": "Entidad publica",
    "clientSelect.other": "Otro",
    "clientSelect.placeholder": "Seleccionar cliente",
    "clientSelect.search": "Buscar cliente...",
    "clientSelect.loading": "Cargando clientes",
    "clientSelect.empty": "Ningun cliente encontrado.",
    "clientSelect.remove": "Eliminar cliente",
    "clientSelect.create": "Crear cliente",
    "clientSelect.namePlaceholder": "Nombre del cliente",
    "clientSelect.createAria": "Crear cliente",
    "clientSelect.updateError": "No fue posible actualizar el cliente.",
    "editor.backToBudgets": "Volver a presupuestos",
    "editor.budgetTrail": "Presupuestos /",
    "editor.referenceAria": "Referencia del presupuesto",
    "editor.clientAria": "Cliente",
    "editor.clientPlaceholder": "Cliente por definir",
    "editor.save.idle": "Sin cambios",
    "editor.save.saving": "Guardando...",
    "editor.save.saved": "Guardado",
    "editor.save.error": "Error al guardar",
    "editor.saveButton.saving": "Guardando",
    "editor.saveButton": "Guardar",
    "editor.export": "Exportar",
    "editor.createWork": "Crear obra",
    "editor.approve": "Aprobar",
    "editor.moreActions": "Mas acciones",
    "editor.duplicate": "Duplicar presupuesto",
    "editor.newVersion": "Nueva version",
    "editor.versionHistory": "Historico de versiones",
    "editor.execution": "Ejecucion y medicion",
    "editor.importIfc": "Importar IFC",
    "permissions.budgets.view": "Ver presupuestos",
    "permissions.budgets.create": "Crear presupuestos",
    "permissions.budgets.edit": "Editar presupuestos",
    "permissions.budgets.delete": "Eliminar presupuestos",
    "permissions.cost_bases.view": "Ver base de precios",
    "permissions.cost_bases.edit": "Editar base de precios",
    "permissions.cost_bases.delete": "Eliminar base de precios",
    "permissions.team.manage": "Gestionar equipo",
    "permissions.admin.access": "Acceder a areas administrativas",
    "costDatabase.resource.count": "{count} recurso{plural}",
    "costDatabase.resource.new": "Nuevo recurso",
    "costDatabase.resource.empty": "Ningun recurso creado todavia. Cree el primero para empezar a montar composiciones.",
    "costDatabase.resource.name": "Nombre",
    "costDatabase.resource.category": "Categoria",
    "costDatabase.resource.unit": "Unidad",
    "costDatabase.resource.price": "Precio",
    "costDatabase.resource.edit": "Editar",
    "costDatabase.resource.delete": "Eliminar",
    "costDatabase.resource.editTitle": "Editar recurso",
    "costDatabase.resource.newTitle": "Nuevo recurso",
    "costDatabase.resource.updated": "Recurso actualizado",
    "costDatabase.resource.created": "Recurso creado",
    "costDatabase.resource.form.name": "Nombre",
    "costDatabase.resource.form.namePlaceholder": "Bloque ceramico 30x20x11",
    "costDatabase.resource.form.category": "Categoria",
    "costDatabase.resource.form.unit": "Unidad",
    "costDatabase.resource.form.basePrice": "Precio base (EUR)",
    "costDatabase.resource.form.priceSource": "Fuente de precio",
    "costDatabase.resource.form.selectSource": "Seleccionar fuente",
    "costDatabase.resource.form.noSource": "Sin fuente",
    "costDatabase.resource.form.referenceDate": "Fecha de referencia",
    "costDatabase.resource.form.notes": "Notas",
    "costDatabase.resource.form.notesPlaceholder": "Observaciones opcionales",
    "costDatabase.resource.form.checkingBenchmark": "Consultando referencia de mercado...",
    "costDatabase.resource.form.accountReference": "Referencia de su cuenta:",
    "costDatabase.resource.form.globalReference": "Referencia global:",
    "costDatabase.resource.form.ownObservations": "{count} observacion(es) propia(s)",
    "costDatabase.resource.form.anonymousObservations": "{count} observacion(es) anonima(s)",
    "costDatabase.resource.form.use": "Usar",
    "costDatabase.resource.form.aboveReference": "Valor por encima de la referencia en {value}%.",
    "costDatabase.resource.form.belowReference": "Valor por debajo de la referencia en {value}%.",
    "costDatabase.resource.form.globalMean": "Media global:",
    "costDatabase.resource.form.globalMedian": "Mediana global:",
    "costDatabase.resource.form.noBenchmark": "No hay referencia suficiente para este recurso y unidad.",
    "costDatabase.resource.form.create": "Crear recurso",
    "costDatabase.resource.category.material": "Material",
    "costDatabase.resource.category.labor": "Mano de obra",
    "costDatabase.resource.category.equipment": "Equipo",
    "costDatabase.resource.category.subcontract": "Subcontrato",
    "costDatabase.resource.category.other": "Otro",
    "costDatabase.dataTier.official": "Oficial",
    "costDatabase.dataTier.scraped": "Raspado",
    "costDatabase.dataTier.user_edited": "Editado por usuario",
    "costDatabase.dataTier.ai_derived": "IA",
    "import.status.pending": "Pendiente",
    "import.status.processing": "Procesando",
    "import.status.review": "En revision",
    "import.status.completed": "Completado",
    "import.status.failed": "Fallido",
    "costDatabase.composition.count": "{count} composicion{plural}",
    "costDatabase.composition.new": "Nueva composicion",
    "costDatabase.composition.empty": "Ninguna composicion creada todavia. Las composiciones agrupan recursos en trabajos presupuestables.",
    "costDatabase.composition.resourcesRequired": "Cree recursos primero. Una composicion necesita al menos un recurso.",
    "costDatabase.composition.editTitle": "Editar composicion",
    "costDatabase.composition.newTitle": "Nueva composicion",
    "costDatabase.composition.updated": "Composicion actualizada",
    "costDatabase.composition.created": "Composicion creada",
    "costDatabase.composition.status.active": "Activa",
    "costDatabase.composition.status.draft": "Borrador",
    "costDatabase.composition.status.archived": "Archivada",
    "costDatabase.composition.form.code": "Codigo",
    "costDatabase.composition.form.unit": "Unidad",
    "costDatabase.composition.form.name": "Nombre",
    "costDatabase.composition.form.namePlaceholder": "Pared interior de ladrillo ceramico e/30",
    "costDatabase.composition.form.description": "Descripcion",
    "costDatabase.composition.form.descriptionPlaceholder": "Especificaciones tecnicas, notas de ejecucion...",
    "costDatabase.composition.form.workCategory": "Categoria de trabajo",
    "costDatabase.composition.form.noCategory": "Sin categoria",
    "costDatabase.composition.form.discipline": "Disciplina",
    "costDatabase.composition.form.noDiscipline": "Sin disciplina",
    "costDatabase.composition.form.status": "Estado",
    "costDatabase.composition.form.selectPlaceholder": "Seleccionar...",
    "costDatabase.composition.form.saveEdit": "Guardar cambios",
    "costDatabase.composition.form.saveCreate": "Crear composicion",
    "costDatabase.compositionItem.resource": "Recurso",
    "costDatabase.compositionItem.quantity": "Cant./unidad",
    "costDatabase.compositionItem.waste": "Merma %",
    "costDatabase.compositionItem.unitPrice": "Precio unit.",
    "costDatabase.compositionItem.totalUnitCost": "Coste unitario total:",
    "costDatabase.compositionItem.addResource": "Anadir recurso",
    "costDatabase.compositionItem.selectResource": "Seleccionar recurso...",
    "costDatabase.compositionItem.allResourcesAdded": "Todos los recursos ya estan anadidos",
    "costDatabase.compositionItem.add": "Anadir",
    "import.upload.currencyRequired": "Moneda obligatoria",
    "import.edit.title": "Editar importacion",
    "import.edit.description": "Ajuste los metadatos de esta base importada sin reenviar el fichero.",
    "import.edit.save": "Guardar cambios",
    "import.delete.title": "Eliminar importacion",
    "import.delete.description": "Se eliminara la importacion \"{name}\". Las filas en staging, mapeos y conflictos asociados se eliminaran. Los datos ya promovidos a la base principal no se eliminan automaticamente.",
    "import.delete.descriptionFallback": "Se eliminara esta importacion. Las filas en staging, mapeos y conflictos asociados se eliminaran. Los datos ya promovidos a la base principal no se eliminan automaticamente.",
    "import.updated": "Importacion actualizada",
    "import.deleted": "Importacion eliminada",
    "import.fileType.title": "Elegir tipo de fichero",
    "import.fileType.description": "Seleccione primero el formato de la base que quiere importar. El panel correspondiente aparece debajo.",
    "import.fileType.bc3.description": "Capitulos, composiciones y recursos estructurados.",
    "import.fileType.xlsx.description": "Hojas de costes y catalogos tabulares.",
    "import.fileType.json.description": "Carga desde colector externo o integracion.",
    "import.jobs.count": "{count} job{plural} de importacion (BC3, XLSX, JSON...)"
  },
};
